window.MTGGoldfish = window.MTGGoldfish || {};
window.MTGGoldfish.onDocumentReadyArray = window.MTGGoldfish.onDocumentReadyArray || [];
window.MTGGoldfish.onDocumentReadyArray.push(function() {
  //determines if the user has a set theme
  function detectColorScheme(){
      var theme="light";    //default to light

      //local storage is used to override OS theme settings
      var preference = Cookies.get('theme');
      if(preference) {
          if(preference === "dark" || preference === "light") {
              theme = preference;
          }
      } else if(!window.matchMedia) {
          //matchMedia method not supported
          return false;
      } else if(window.matchMedia("(prefers-color-scheme: dark)").matches) {
          //OS theme setting detected as dark
          theme = "dark";
      }

      //dark theme preferred, set document with a `data-bs-theme` attribute
      if (theme=="dark") {
          var toggle = document.getElementById("btn-toggle-dark");
          if (toggle) toggle.checked = true;
          document.documentElement.setAttribute("data-bs-theme", "dark");
      } else {
          document.documentElement.setAttribute("data-bs-theme", "light");
      }
  }
  detectColorScheme();
  document.addEventListener('change', function(e) {
    if (!e.target || e.target.id !== 'btn-toggle-dark') return;
    if (e.target.checked) {
      document.documentElement.setAttribute("data-bs-theme", "dark");
      Cookies.set('theme', 'dark', { expires: 3650, path: '/' });
    } else {
      document.documentElement.setAttribute("data-bs-theme", "light");
      Cookies.set('theme', 'light', { expires: 3650, path: '/' });
    }
  });
});
